/**
 * subcollection-section.js — DeoDap
 *
 * The .deo-subcoll-track container is a plain scrollable flex row by
 * default — always visible, zero JS dependency.
 * This script upgrades it to a Swiper carousel when Swiper is ready.
 */
(function () {
  function initSwiper() {
    var track = document.querySelector('.deo-subcoll-track');
    if (!track || typeof window.Swiper === 'undefined') return;

    // Convert each .deo-subcoll-item into a swiper-slide wrapper
    var items = track.querySelectorAll('.deo-subcoll-item');
    items.forEach(function (item) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      track.insertBefore(slide, item);
      slide.appendChild(item);
    });

    // Wrap all slides in a swiper-wrapper div (required by Swiper)
    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    while (track.firstChild) {
      wrapper.appendChild(track.firstChild);
    }
    track.appendChild(wrapper);

    // Add nav buttons
    var prev = document.createElement('div');
    prev.className = 'deo-subcoll-prev';
    var next = document.createElement('div');
    next.className = 'deo-subcoll-next';
    track.appendChild(prev);
    track.appendChild(next);

    track.style.position = 'relative';

    // Mark the viewport so native arrows hide (fallback for browsers without :has())
    var vp = track.closest('.deo-subcoll-viewport');
    if (vp) vp.classList.add('deo-subcoll-swiper-on');

    new window.Swiper(track, {
      slidesPerView: 7,
      spaceBetween: 15,
      navigation: { nextEl: next, prevEl: prev },
      loop: false,
      breakpoints: {
        1024: { slidesPerView: 7,   spaceBetween: 20 },
        750:  { slidesPerView: 5,   spaceBetween: 15 },
        640:  { slidesPerView: 4.5, spaceBetween: 12 },
        420:  { slidesPerView: 3.5, spaceBetween: 10 },
        320:  { slidesPerView: 3,   spaceBetween: 8  },
      },
    });
  }

  // Native arrow buttons — scroll the rail directly. Works with or without Swiper.
  function initNativeArrows() {
    var viewports = document.querySelectorAll('.deo-subcoll-viewport');
    viewports.forEach(function (vp) {
      var track = vp.querySelector('.deo-subcoll-track');
      var prev  = vp.querySelector('.deo-subcoll-arrow--prev');
      var next  = vp.querySelector('.deo-subcoll-arrow--next');
      if (!track || !prev || !next) return;

      function scrollAmount() {
        // scroll by ~80% of the visible width
        return Math.max(track.clientWidth * 0.8, 150);
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.classList.toggle('is-hidden', track.scrollLeft <= 0);
        next.classList.toggle('is-hidden', track.scrollLeft >= maxScroll);
        // If nothing to scroll at all, hide both
        if (track.scrollWidth <= track.clientWidth + 2) {
          prev.classList.add('is-hidden');
          next.classList.add('is-hidden');
        }
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    });
  }

  function whenReady(fn) {
    var domReady    = document.readyState !== 'loading';
    var swiperReady = typeof window.Swiper !== 'undefined';

    if (domReady && swiperReady) { fn(); return; }

    var pendingDom = !domReady, pendingSwiper = !swiperReady;
    function maybeRun() { if (!pendingDom && !pendingSwiper) fn(); }

    if (pendingDom) {
      document.addEventListener('DOMContentLoaded', function () {
        pendingDom = false; maybeRun();
      }, { once: true });
    }
    if (pendingSwiper) {
      window.addEventListener('swiper:ready', function () {
        pendingSwiper = false; maybeRun();
      }, { once: true });
    }
  }

  // Native arrows should work immediately, independent of Swiper.
  if (document.readyState !== 'loading') {
    initNativeArrows();
  } else {
    document.addEventListener('DOMContentLoaded', initNativeArrows, { once: true });
  }

  whenReady(initSwiper);
})();